import { render, staticRenderFns } from "./AgenciaObjetivoDashboardAdminPage.vue?vue&type=template&id=4ac1157c"
import script from "./AgenciaObjetivoDashboardAdminPage.vue?vue&type=script&lang=js"
export * from "./AgenciaObjetivoDashboardAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports